import { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { LookupItem } from "../../../Shared/Models/LookupItem";
import { CCBlock, ClinicalStatus } from "../../../Physician/Models/CCBlock";
import { abpnClient } from "../../../../Services/AbpnClient";
import { AuthContext } from "../../../Auth/AuthProvider";
import { deepCopy } from "../../../Shared/Utility/DeepCopy";
import React from "react";
import Physician from "../../../Physician/Models/Physician";

interface IProps {
    ccBlock: CCBlock;
    physician: Physician;
    updatePhysician: (updatedPhysician: Physician) => void;
    editable: boolean;
}

export default function ClinicalStatusRow(props: IProps) {
    const authContext = useContext(AuthContext);
    const [clinicalStatus, setClinicalStatus] = useState(props.ccBlock.clinicalStatus);
    const [newClinicalStatus, setNewClinicalStatus] = useState(2);
    const [isEditing, setIsEditing] = useState(false);
    const [ccBlock, setCCBlock] = useState(deepCopy(props.ccBlock));
    const [physician, setPhysician] = useState(deepCopy(props.physician));

    useEffect(() => {
        setCCBlock(deepCopy(props.ccBlock));
        setPhysician(deepCopy(props.physician));
    }, [props.physician]);

    const beginEdit = () => {
        setIsEditing(true);
    }

    const cancel = () => {
        setIsEditing(false);
    }

    const save = async () => {
        ccBlock.clinicalStatus = newClinicalStatus;

        await abpnClient.post("/api/physician/UpdateClinicalStatus", ccBlock, authContext);
        setClinicalStatus(newClinicalStatus);
        setIsEditing(false);

        physician.currentCCEnrollment.ccBlocks.find(_=>_.ccBlockId == ccBlock.ccBlockId).clinicalStatus = newClinicalStatus;
        if(ccBlock.ccBlockId == physician.currentCCEnrollment.currentCCBlock.ccBlockId)
            physician.currentCCEnrollment.currentCCBlock = ccBlock;
        props.updatePhysician(physician);
    }

    let clinicalStatusOptions: Array<LookupItem> = [];

    for (let key in ClinicalStatus) {
        let value = ClinicalStatus[key];
        clinicalStatusOptions.push({ id: parseInt(key), name: value })
    }

    return (
        <Fragment>
        {props.editable && 
            <Row>
                <Col>
                    <a href="https://abpn.org/maintain-certification/cc-program/clinical-activity-status/"
                        className="font-weight-bolder mb-1 pp-font-size-smaller">
                        Clinical Status
                        <OverlayTrigger
                            placement={"left"}
                            overlay={<Tooltip id="contactAddress" bsPrefix="pp-tooltip">
                                Diplomates are required to update their clinical status.   There are three designations:<br />
                                <ul>
                                    <li><b>Active</b>- Physicians who are treating patients. These diplomates need to complete the PIP requirement.</li>
                                    <li><b>Active, Not Enough for PIP</b>- Physicians who are active, but are primarily in research, academic, or administrative roles insufficient to complete the PIP requirement.</li>
                                    <li><b>Inactive</b>- Physicians who are not clinically active (i.e. medical leave, not practicing).</li>
                                </ul>
                                If a diplomate is active in at least one certification, they will need to complete the PIP requirement.
                            </Tooltip>}>
                            <i className="las la-info-circle ml-1 text-pp-secondary"></i>
                        </OverlayTrigger>
                    </a>
                    {isEditing ?
                        <Form.Control as="select"
                            required
                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {setNewClinicalStatus(parseInt(e.currentTarget.value)); }}
                            defaultValue={clinicalStatus}>
                            <option hidden value="">Select One</option>
                            {clinicalStatusOptions.map(x => (<option value={x.id} key={x.id}>{x.name}</option>))}
                        </Form.Control>
                        :
                        <div className="pp-font-size-smaller">{ClinicalStatus[clinicalStatus]}</div>
                    }
                </Col>
                <Col>
                    {isEditing ?
                        <Fragment>
                            <Button variant="pp-primary" className="mr-2" onClick={() => save()}>
                                Save
                            </Button>
                            <Button variant="outline-pp-primary" onClick={() => cancel()}>
                                Cancel
                            </Button>
                        </Fragment>
                        :
                        <Button variant="outline-pp-primary" className="ml-1" onClick={() => beginEdit()}>
                            <b>Edit</b>
                        </Button>
                    }
                </Col>
            </Row>
        }
        {!props.editable &&
            <Row>
                <Col>
                <a href="https://abpn.org/maintain-certification/cc-program/clinical-activity-status/"
                    className="font-weight-bolder mb-1 pp-font-size-smaller">
                    Clinical Status
                    <OverlayTrigger
                        placement={"left"}
                        overlay={<Tooltip id="contactAddress" bsPrefix="pp-tooltip">
                            Diplomates are required to update their clinical status.   There are three designations:<br />
                            <ul>
                                <li><b>Active</b>- Physicians who are treating patients. These diplomates need to complete the PIP requirement.</li>
                                <li><b>Active, Not Enough for PIP</b>- Physicians who are active, but are primarily in research, academic, or administrative roles insufficient to complete the PIP requirement.</li>
                                <li><b>Inactive</b>- Physicians who are not clinically active (i.e. medical leave, not practicing).</li>
                            </ul>
                            If a diplomate is active in at least one certification, they will need to complete the PIP requirement.
                        </Tooltip>}>
                        <i className="las la-info-circle ml-1 text-pp-secondary"></i>
                    </OverlayTrigger>
                </a>
                <div className="pp-font-size-smaller" key={props.ccBlock.clinicalStatus}>{ClinicalStatus[props.ccBlock.clinicalStatus]}</div>
                </Col>
                <Col>
                    <Button variant="outline-pp-primary" className="ml-1" disabled={true} onClick={() => beginEdit()}>
                        <b>Edit</b>
                    </Button>
                </Col>
            </Row>
        }
        </Fragment>
    );
}